module.exports = __webpack_public_path__ + "img/home_productone.aedf2657.jpg";